import ordersService from '../../services/orders'

const state = {
  restaurants : [],
  totalAmount : 0,
  totalOrders : 0,
  charts : []
}
 
// getters
const getters = {
  totalRevenue: state => {
    let total = 0;
    state.restaurants.forEach(r => {
      r.currentOrders.forEach(o => {
        total += o.total;
      })
    });
    return total;
  },
  totalOrders : state => {
    let total = 0;
    state.restaurants.forEach(r => {
      total += r.currentOrders.length;
    });
    return total;
  },
  totalRevenueByRestaurant: (state) => (id) => {
    let restaurant = state.restaurants.find(r => r.restaurantId === id);
    if (restaurant != null) {
      return restaurant.totalRevenue;
    }
    else {
      return 0;
    }
    
  },
  totalOrdersByRestaurant: (state) => (id) => {
    let restaurant = state.restaurants.find(r => r.restaurantId === id);
    if (restaurant != null) {
      return restaurant.currentOrders.length;
    }
    else {
      return 0;
    }
  },
  charts: state => {
    //
    //calculate total revenue
    //
    let rows = [];
    state.restaurants.forEach(r => {
      let sum = 0;
      r.currentOrders.forEach(o => {
        sum += o.total;
      })
      let row = {
        'restaurant' : r.restaurantName,
        'total' : sum
      };
      rows.push(row);
    });
    return rows;
  }
 
}
 
// actions
const actions = {
    async getCurrentOrdersByRestaurantOwnerAction(context) {
      await ordersService.getCurrentOrdersByRestaurantOwner()
                         .then(data => {
                           context.commit('setCurrentOrdersByRestaurantOwnerState', data);
                         })
  }
}

// mutations
const mutations = {
  initializeCurrentOrdersState(state, restaurants) {
    for (var i = 0; i < restaurants.length; i++) {
      let restaurant = {
        restaurantId : restaurants[i].restaurantId,
        currentOrders : [],
        totalRevenue : 0
      };
      state.restaurants.push(restaurant);
    }
  },
  addNewOrderByRestaurantState(state, payload) {
    let index = state.restaurants
                     .findIndex(i => i.restaurantId === payload.restaurantId);
    if (index > -1) {
      state.restaurants[index].currentOrders.push(payload.order);
    }
  },
  setCurrentOrdersByRestaurantOwnerState(state, payload) {
    state.restaurants = payload;
    state.charts = [];
    let totalOrders = 0;
    

    //
    //calculate total orders
    //
    state.restaurants.forEach(r => {
      totalOrders += r.currentOrders.length;
    });

    state.totalOrders = totalOrders;



  } 
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}